import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import storeService from "services/storeService";

export const login = createAsyncThunk(
	"store/login",
	async (appKey, { dispatch }) => {
		try {
			dispatch(showLoader());
			dispatch(setAuthenticating(true));
			await storeService.login(appKey);
			const store = await storeService.fetch();
			return { ...store, isAuthenticating: false, isAuthenticated: true };
		} catch (error) {
			console.error(error);
			dispatch(
				showMessage({
					message: "Error occurred while loading",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
			dispatch(setAuthenticating(false));
		}
	}
);

const storeSlice = createSlice({
	name: "vino/store",
	initialState: {
		zipCode: "",
		isAuthenticating: false,
		isAuthenticated: false,
	},
	reducers: {
		setAuthenticating: (state, action) => {
			state.isAuthenticating = action.payload;
		},
	},
	extraReducers: {
		[login.fulfilled]: (state, action) => action.payload,
	},
});

export const { setAuthenticating } = storeSlice.actions;

export default storeSlice.reducer;
